<template>
  <div
    class="container-fluid"
    :class="`container-fluid--${colorTheme}`"
    :style="`padding-top: ${top}rem; padding-bottom: ${bottom}rem;`"
    v-show="couponExists"
  >
    <div class="container" :class="`container--${disabled ? 'disabled' : ''}`">
      <h1 class="container__title text--h4" v-html="getParsedTitle" />
      <div class="container__content text--h6" v-html="getParsedContent"></div>
      <div class="container__coupon coupon">
        <ul class="coupon__list">
          <li
            class="coupon__item"
            v-for="(coupon, key) in coupons"
            :style="`background-color: ${couponColor}; color: ${couponTextColor}`"
            :key="key"
          >
            <div class="coupon__inner">
              <div class="coupon__container">
                <div class="coupon__price">
                  <h3 class="coupon__label text--content1">COUPON</h3>
                  <span :class="`coupon__price-point coupon__price-point--${couponType(coupon)} text--h3`"
                    ><template v-if="couponType(coupon) === 'rate'">{{
                      displayWithCommas(coupon.discountRate)
                    }}</template
                    ><template v-if="couponType(coupon) === 'amount'">{{
                      displayWithCommas(coupon.discountAmount)
                    }}</template>
                  </span>
                </div>
                <div class="coupon__dot-line dot-line dot-line--outer">
                  <div class="dot-line dot-line--inner"></div>
                </div>
                <div class="coupon__name">
                  <p class="text--h6" v-html="coupon.title" />
                </div>
              </div>
            </div>
          </li>
        </ul>
        <div class="coupon__remaining" v-if="showCouponCount">
          <template v-if="isActive">{{ stock }}</template>
          <template v-if="!isActive">0</template>
        </div>
      </div>
      <div class="container__button">
        <button class="container__button-cta button-cta" @click="getCoupons" :disabled="isPending || disabled">
          <span class="button-cta__icon-download"></span>
          <span class="button-cta__text">
            <template v-if="!isActive">쿠폰 기간 만료</template>
            <template v-if="isActive">
              <template v-if="hasCoupons">쿠폰 발급 완료</template>
              <template v-if="!hasCoupons && stock !== 0">{{ buttonText || '쿠폰 모두 받기' }}</template>
              <template v-if="!hasCoupons && stock === 0">쿠폰 재고 소진</template>
            </template>
          </span>
        </button>
      </div>
    </div>
    <popup
      :visible="visible"
      :type="type"
      :title="popupInfo.title"
      :subtitle="popupInfo.subtitle"
      :buttonText="'확인'"
      @close="load"
    />
  </div>
</template>
<script>
import moment from 'moment';
import { ERRORS } from '../redeem-message';
import Popup from './../popup/app';
import api from './api';
import auth from '../auth';

export default {
  name: 'branding',
  data() {
    return {
      isPending: false,
      type: '',
      visible: false,
      coupons: [],
      popupInfo: {
        title: '쿠폰 발급',
        subtitle: '제목',
      },
      userCoupons: [],
    };
  },
  components: {
    Popup,
  },
  props: [
    'buttonText',
    'colorTheme',
    'title',
    'content',
    'couponColor',
    'couponTextColor',
    'couponCodes',
    'showRemainingCoupons',
    'paddingTop',
    'paddingBottom',
  ],
  mixins: [auth],
  computed: {
    couponExists() {
      return this.coupons?.length > 0;
    },
    hasCoupons() {
      return this.userCoupons.some(
        (userCoupon) => this.coupons.filter((coupon) => userCoupon.code.split('_')[0] === coupon.code).length > 0
      );
    },
    showCouponCount() {
      return this.showRemainingCoupons === 'true';
    },
    disabled() {
      return this.stock === 0 || this.hasCoupons || !this.isActive;
    },
    stock() {
      const coupons = [...this.coupons];
      coupons.sort((a, b) => a.stock - b.stock);
      return (coupons[0] && coupons[0].stock) || 0;
    },
    top() {
      return this.paddingTop / 10;
    },
    bottom() {
      return this.paddingBottom / 10;
    },
    getParsedTitle() {
      return this.title || '제목을 입력해주세요.';
    },
    getParsedContent() {
      return this.content || '본문을 입력해주세요.';
    },
    isActive() {
      return this.coupons.every((coupon) => moment().isBetween(coupon.showAt, coupon.hideAt));
    },
  },
  methods: {
    sortedCoupons() {
      let couponCodeOrder = this.couponCodes.split(',');

      this.coupons.sort((a, b) => {
        if (couponCodeOrder.indexOf(a.code) > couponCodeOrder.indexOf(b.code)) {
          return 1;
        } else {
          return -1;
        }
      });
    },
    couponType(coupon) {
      if (coupon.discountRate || (coupon.discountRate && coupon.discountAmount)) {
        return 'rate';
      }

      return 'amount';
    },
    async loadUserInfo() {
      // 로그인된 사용자의 쿠폰 리스트 가져오기
      if (localStorage.getItem('fc-access-token')) {
        this.authorize('signIn');
        const {
          data: {
            data: { userCoupons },
          },
        } = await api.getUserInfo();
        this.userCoupons = userCoupons;
      }
    },
    async load() {
      // 레이아웃 쿠폰 리스트 가져오기
      const {
        data: {
          data: { coupons },
        },
      } = await api.getCoupons(
        this.couponCodes
          .split(',')
          .map((couponCode) => `code=${couponCode}`)
          .join('&')
      );

      this.coupons = coupons;
      this.sortedCoupons();
      await this.loadUserInfo();
    },
    displayWithCommas(number) {
      return (number && number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')) || '';
    },
    requestCoupon() {
      setTimeout(async () => {
        await this.loadUserInfo();

        try {
          this.isPending = true;

          const {
            data: {
              data: { couponIds },
            },
          } = await api.requestCoupons(this.coupons.map((coupon) => coupon.code));
          this.popupInfo.title = '쿠폰 발급 완료';
          this.popupInfo.subtitle = `
            총 <span style="font-weight: bold">${couponIds.length}개</span>의 쿠폰 발급이 완료되었습니다.<br>
            발급된 쿠폰은 <a href="/me/coupon"><span style="font-weight: bold;text-decoration: underline;">마이페이지 > 쿠폰</span></a>에서 확인하실 수 있습니다.
          `;
          this.type = 'confirm';
          this.visible = true;
        } catch (err) {
          if (err && err.message) {
            this.popupInfo.title = '쿠폰 발급 실패';

            switch (err.message) {
              case ERRORS.INVALID_ACCESS_TOKEN:
                this.close();
                this.authorize('signIn', {
                  message: '쿠폰 발급을 위해, 로그인 해주세요.',
                });
                break;
              case ERRORS.USER_COUPON_DUPLICATED_ERROR:
              case ERRORS.USER_POPUP_DUPLICATED_ERROR:
                this.popupInfo.subtitle = `이미 발급받은 쿠폰입니다.`;
                this.type = 'confirm';
                this.visible = true;
                break;
              case ERRORS.COUPON_INVALID:
                this.popupInfo.subtitle = `쿠폰 재고가 전부 소진되었습니다.`;

                if (this.hasCoupons) {
                  this.popupInfo.subtitle = `이미 발급받은 쿠폰입니다.`;
                }
                this.type = 'confirm';
                this.visible = true;
                break;
              case ERRORS.POPUP_NOT_FOUND:
                this.popupInfo.subtitle = `기간이 종료되었습니다.`;
                this.type = 'confirm';
                this.visible = true;
                break;
              case ERRORS.COUPON_REDEEM_FAILED:
              default:
                this.popupInfo.subtitle = `
                 불편을 드려 죄송합니다.<br/>
                 알 수 없는 오류로 쿠폰이 지급되지 않았습니다.<br/>
                 잠시 후 다시 시도해 주세요.
                `;
                this.type = 'confirm';
                this.visible = true;
            }
          }
        } finally {
          this.isPending = false;
        }
      }, 0);
    },
    getCoupons() {
      this.close();
      this.requestCoupon();
    },
    close() {
      this.visible = false;
    },
  },
  mounted() {
    this.load();
  },
};
</script>
<style lang="scss">
.coupon {
  &__price-point {
    &--amount {
      &::before {
        content: '₩';
      }
    }

    &--rate {
      &::after {
        content: '%';
      }
    }
  }
}

.container-fluid {
  .button-cta {
    &__text {
      line-height: 1.4;
    }
  }

  &--bright {
    .container--disabled {
      .container {
        &__coupon {
          .coupon {
            &__item {
              border: 0.1rem solid #d3d3d3 !important;

              background-color: #fff !important;

              color: #aaaaaf !important;
            }

            &__inner {
              background-image: linear-gradient(0deg, transparent, transparent) !important;
            }

            &__remaining {
              color: #aaaaaf !important;
            }
          }

          .dot-line {
            &--outer {
              &::before,
              &::after {
                border-top: 0.1rem solid #d3d3d3 !important;
                border-bottom: 0.1rem solid #d3d3d3 !important;
              }

              &::before {
                left: -0.1rem !important;

                border-right: 0.1rem solid #d3d3d3 !important;
                border-left: 0.1rem solid #fff !important;
              }

              &::after {
                right: -0.1rem !important;

                border-right: 0.1rem solid #fff !important;
                border-left: 0.1rem solid #d3d3d3 !important;
              }
            }

            &--inner {
              background: url("data:image/svg+xml,%3Csvg width='178' height='2' viewBox='0 0 178 2' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='1' cy='1' r='1' fill='%23D3D3D3'/%3E%3Ccircle cx='9' cy='1' r='1' fill='%23D3D3D3'/%3E%3Ccircle cx='17' cy='1' r='1' fill='%23D3D3D3'/%3E%3Ccircle cx='25' cy='1' r='1' fill='%23D3D3D3'/%3E%3Ccircle cx='33' cy='1' r='1' fill='%23D3D3D3'/%3E%3Ccircle cx='41' cy='1' r='1' fill='%23D3D3D3'/%3E%3Ccircle cx='49' cy='1' r='1' fill='%23D3D3D3'/%3E%3Ccircle cx='57' cy='1' r='1' fill='%23D3D3D3'/%3E%3Ccircle cx='65' cy='1' r='1' fill='%23D3D3D3'/%3E%3Ccircle cx='73' cy='1' r='1' fill='%23D3D3D3'/%3E%3Ccircle cx='81' cy='1' r='1' fill='%23D3D3D3'/%3E%3Ccircle cx='89' cy='1' r='1' fill='%23D3D3D3'/%3E%3Ccircle cx='97' cy='1' r='1' fill='%23D3D3D3'/%3E%3Ccircle cx='105' cy='1' r='1' fill='%23D3D3D3'/%3E%3Ccircle cx='113' cy='1' r='1' fill='%23D3D3D3'/%3E%3Ccircle cx='121' cy='1' r='1' fill='%23D3D3D3'/%3E%3Ccircle cx='129' cy='1' r='1' fill='%23D3D3D3'/%3E%3Ccircle cx='137' cy='1' r='1' fill='%23D3D3D3'/%3E%3Ccircle cx='145' cy='1' r='1' fill='%23D3D3D3'/%3E%3Ccircle cx='153' cy='1' r='1' fill='%23D3D3D3'/%3E%3Ccircle cx='161' cy='1' r='1' fill='%23D3D3D3'/%3E%3Ccircle cx='169' cy='1' r='1' fill='%23D3D3D3'/%3E%3Ccircle cx='177' cy='1' r='1' fill='%23D3D3D3'/%3E%3C/svg%3E%0A") !important;
            }
          }
        }

        &__button-cta {
          background-color: #ffccd6 !important;
          .button-cta {
            &__icon-download {
              &::before {
                content: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M2 13V17H18V13' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M6 8L10 12L14 8' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M10 12V3' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A") !important;
              }
            }
          }
        }
      }
    }
  }

  &--dark {
    .container--disabled {
      .container {
        &__coupon {
          .coupon {
            &__item {
              border: 0.1rem solid #444 !important;

              background-color: #000 !important;

              color: #6e6e73 !important;
            }

            &__inner {
              background-image: linear-gradient(0deg, transparent, transparent) !important;
            }

            &__remaining {
              color: #6e6e73 !important;
            }
          }

          .dot-line {
            &--outer::before,
            &--outer::after {
              border-top: 0.1rem solid #444 !important;
              border-bottom: 0.1rem solid #444 !important;
            }

            &--outer::before {
              left: -0.1rem !important;

              border-right: 0.1rem solid #444 !important;
              border-left: 0.1rem solid #000 !important;
            }

            &--outer::after {
              right: -0.1rem !important;

              border-right: 0.1rem solid #000 !important;
              border-left: 0.1rem solid #444 !important;
            }
          }
        }

        &__button-cta {
          border: 0.1rem solid #444;

          background-color: #000 !important;

          color: #6e6e73 !important;
          .button-cta {
            &__icon-download {
              &::before {
                content: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M2 13V17H18V13' stroke='%236E6E73' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M6 8L10 12L14 8' stroke='%236E6E73' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M10 12V3' stroke='%236E6E73' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A") !important;
              }
            }
          }
        }
      }
    }
  }
}
</style>
